/**
 * The app's primary navigation, in the order the iOS client presents it.
 *
 * Order mirrors `Shutter Up/ShutterUp/App/ContentView.swift:31-70` — Download, History, Settings,
 * Browser, Library — minus Browser, which is a WKWebView with an injected detection script and has
 * no honest web analog. Settings sitting before Library is unusual but is what the app does; keep
 * the two clients aligned rather than "fixing" the order here alone.
 *
 * History is absent until SHUT-35 ships the surface behind it. A tab that renders a placeholder
 * would be the shipped-but-unwired pattern SHUT-4 exists to fix, so tabs appear only once their
 * destination is real.
 */
export interface TabDescriptor {
  readonly id: 'download' | 'history' | 'settings' | 'library'
  readonly label: string
  /** Internal router path, or an absolute path for a surface not yet ported into the SPA. */
  readonly to: string
  /**
   * True while this tab still points at a backend-served page. SHUT-32 (Library) and SHUT-34
   * (Settings) flip these to internal routes; SHUT-38 then deletes the pages they leave behind.
   */
  readonly external?: boolean
}

export const TABS: readonly TabDescriptor[] = [
  { id: 'download', label: 'Download', to: '/' },
  { id: 'settings', label: 'Settings', to: '/settings.html', external: true },
  { id: 'library', label: 'Library', to: '/gallery.html', external: true },
]
